import axios from "axios";
import Vue from "vue";
import { BASEURL } from "@/config/index";
// import router from '../router';

export default () => {
  const instance = axios.create({
    baseURL: BASEURL
  });
  let JWT = window.localStorage.getItem("JWT_TOKEN");
  if (JWT) {
    instance.defaults.headers.common["Authorization"] = JWT;
  }
  // instance.defaults.headers.common['Authorization'] = Vue.cookie.get('STRHTID')
  // instance.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
  instance.interceptors.response.use(
    function(response) {
      // Do something with response data
      return response;
    },
    function(error) {
      // Do something with response error
      if (error && error.response && error.response.status == 403) {
        // vmVue.$router.push({
        //   path: "/access-denied"
        // });
        Vue.toasted.show("You are not authorized");
      } else if (error && error.response && error.response.status == 401) {
        localStorage.clear();
        Vue.cookie.delete("BRHSID");
        vmVue.$router.push({
          path: "/" // '/go-to-login'
        });
      } else if (error.code === 'ECONNABORTED' || !error.response) {

        const CRITICAL_ENDPOINTS = [
          `/user/check`,
          `/api/admin/getOrgDetails`,
          `/health-meta`,
          `/checkOnlyAuthenticatorEnabled`,
          `/api/admin`,
          `/api/`,
          `/api/pos/`,
        ]

        const requestPath = new URL(error.config.url, error.config.baseURL).pathname;

        const isCritical = CRITICAL_ENDPOINTS.some(endpoint =>
          requestPath.startsWith(endpoint)
        );

         const currentRoute = vmVue.$router.currentRoute['path'];

        if (isCritical &&  currentRoute !== '/connection-issue') {
          // Timeout or network/server unreachable
          vmVue.$router.push({
            path: "/connection-issue",
          });
        } else {
          return Promise.reject(error);
        }
      } else {
        return Promise.reject(error);
      }
    }
  );
  return instance;
};



// WEBPACK FOOTER //
// ./src/services/Api.js